import { render, staticRenderFns } from "./StepDataIngestion.vue?vue&type=template&id=6eda1936&scoped=true&"
import script from "./StepDataIngestion.vue?vue&type=script&lang=js&"
export * from "./StepDataIngestion.vue?vue&type=script&lang=js&"
import style0 from "./StepDataIngestion.vue?vue&type=style&index=0&id=6eda1936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eda1936",
  null
  
)

export default component.exports